let addedSettingsListenersAlready;

function renderUserSettings() {
	if (!nthAdmin) return;

	const overviewAdminControls = document.getElementById('overviewAdminControls');
	if (overviewAdminControls) overviewAdminControls.classList.remove('hidden');
	const hideCTAbutton = document.getElementById('hideCTAbutton');
	const showAggregate = document.getElementById('showAggregate');
	const includeGains = document.getElementById('includeGains');
	const showSmallValues = document.getElementById('showSmallValues');

	const showHideUserTabsDiv = document.getElementById('showHideUserTabsDiv');
	const userTabsToggglesDiv = document.getElementById('userTabsToggglesDiv');
	const campaignToggle = document.getElementById('campaignToggle');
	const reportsToggle = document.getElementById('reportsToggle');
	const updatesToggle = document.getElementById('updatesToggle');
	const yourDocsToggle = document.getElementById('yourDocsToggle');
	const dataRoomToggle = document.getElementById('dataRoomToggle');
	const companyCalendarToggle = document.getElementById('companyCalendarToggle');

	const labelUpdatesElem = document.getElementById('labelUpdatesElem');
	const labelReportsElem = document.getElementById('labelReportsElem');
	const labelPortfolioElem = document.getElementById('labelPortfolioElem');
	const labelTeamElem = document.getElementById('labelTeamElem');
	const labelFinStmntsElem = document.getElementById('labelFinStmntsElem');
	const labelCompanyDocsElem = document.getElementById('labelCompanyDocsElem');
	const saveLabelsTabs = document.getElementById('saveLabelsTabs');

	// labelOwnershipElem.placeholder = clientData.use_fund_language ? "Percent" : "Ownership";
	// labelShareholdersElem.placeholder = clientData.use_fund_language ? "Investors" : "Shareholders";
	// labelInvestmentsElem.placeholder = clientData.use_real_estate_language ? "Properties" : clientData.use_fund_language ? "Funds" : "Classes";

	if (!clientData.language) clientData.language = {};
	let language = clientData.language;
	if (language.label_updates_tab) labelUpdatesElem.value = language.label_updates_tab;
	if (language.label_reports_tab) labelReportsElem.value = language.label_reports_tab;
	if (language.label_portfolio_tab) labelPortfolioElem.value = language.label_portfolio_tab;
	if (language.label_team_tab) labelTeamElem.value = language.label_team_tab;
	if (language.label_financial_statements) labelFinStmntsElem.value = language.label_financial_statements;
	if (language.label_company_documents) labelCompanyDocsElem.value = language.label_company_documents;

	let flags = clientData.flags || {};
	hideCTAbutton.checked = flags.hide_cta_button;
	showAggregate.checked = flags.show_aggregate;
	includeGains.checked = flags.include_gains;
	showSmallValues.checked = flags.show_last_invited;

	let tabs = clientData.tabs || {};

	campaignToggle.checked = tabs.show_campaign;
	reportsToggle.checked = !tabs.hide_reports;
	updatesToggle.checked = !tabs.hide_updates;
	yourDocsToggle.checked = !tabs.hide_your_docs;
	dataRoomToggle.checked = tabs.show_data_room;
	companyCalendarToggle.checked = tabs.show_small_values;

	// Select all toggle inputs
	const toggles = document.querySelectorAll('#editSettingsOverview input[type="checkbox"]');

	// Add event listeners to each toggle
	if (!addedSettingsListenersAlready) {
		addedSettingsListenersAlready = true;
		showHideUserTabsDiv.addEventListener('click', function (e) {
			if (this.innerHTML.startsWith('Show')) {
				userTabsToggglesDiv.hidden = false;
				this.innerHTML = 'Hide Toggles and Labels for User Tabs';
			} else {
				userTabsToggglesDiv.hidden = true;
				this.innerHTML = 'Show Toggles and Labels for User Tabs';
			}
		});

		saveLabelsTabs.addEventListener('click', function (e) {
			const labels = {
				label_updates_tab: labelUpdatesElem.value,
				label_reports_tab: labelReportsElem.value,
				label_portfolio_tab: labelPortfolioElem.value,
				label_team_tab: labelTeamElem.value,
				label_financial_statements: labelFinStmntsElem.value,
				label_company_documents: labelCompanyDocsElem.value,
			};

			Object.keys(labels).forEach((key) => {
				if (labels[key]) language[key] = labels[key];
				else delete language[key];
			});

			sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

			let apiUrl = 'https://api.nthround.io/portal/clientConfig/language';
			let params = { client: client, userid: authedUser, cookie: cookie };
			params.language = clientData.language;
			axios
				.patch(apiUrl, { body: 'body' }, { params })
				.then(function (response) {
					console.log(response);
					showToast('success-toast', 'All labels updated. On closing this modal, your browser will refresh.');
					const editSettingsOverview = document.getElementById('editSettingsOverview');
					M.Modal.getInstance(editSettingsOverview).options.onCloseEnd = () => {
						location.reload();
					};
				})
				.catch(function (error) {
					console.error(error);
				});
		});

		toggles.forEach((toggle) => {
			toggle.addEventListener('change', (event) => {
				const toggleId = event.target.id;
				const isChecked = event.target.checked;

				// Define mappings for toggles and their respective APIs
				const tabsMapping = {
					hideCTAbutton: { key: 'hide_cta_button', api: 'flags', negate: false },
					showAggregate: { key: 'show_aggregate', api: 'flags', negate: false },
					includeGains: { key: 'include_gains', api: 'flags', negate: false },
					showSmallValues: { key: 'show_small_values', api: 'flags', negate: false },
					autoJoin: { key: 'auto_join', api: 'flags', negate: false },

					campaignToggle: { key: 'show_campaign', api: 'tabs', negate: false },
					reportsToggle: { key: 'hide_reports', api: 'tabs', negate: true },
					updatesToggle: { key: 'hide_updates', api: 'tabs', negate: true },
					yourDocsToggle: { key: 'hide_your_docs', api: 'tabs', negate: true },
					dataRoomToggle: { key: 'show_data_room', api: 'tabs', negate: false },
					companyCalendarToggle: { key: 'show_company_calendar', api: 'tabs', negate: false },
				};

				if (!clientData.tabs) clientData.tabs = {};
				if (!clientData.flags) clientData.flags = {};

				// Check if toggleId matches a mapping
				let api;
				if (tabsMapping[toggleId]) {
					const { key, api: newApi, negate } = tabsMapping[toggleId];
					api = newApi; // Set the correct API
					if (api == 'tabs')
						clientData.tabs[key] = negate ? !isChecked : isChecked; // Apply the toggle state with negation if needed
					else if (api == 'flags') clientData.flags[key] = negate ? !isChecked : isChecked;
				} else {
					console.error(`Unknown toggleId: ${toggleId}`);
				}

				sessionStorage.setItem(client + '.Data', JSON.stringify(clientData));

				let apiUrl = 'https://api.nthround.io/portal/clientConfig/' + api;
				let params = { client: client, userid: authedUser, cookie: cookie };
				if (api == 'tabs') params.tabs = clientData.tabs;
				else if (api == 'flags') params.flags = clientData.flags;
				axios
					.patch(
						apiUrl,
						{
							body: 'body',
						},
						{
							params,
						}
					)
					.then(function (response) {
						console.log(response);
						showToast('success-toast', 'Settings updated. On closing this modal, your browser will refresh.');
						const editSettingsOverview = document.getElementById('editSettingsOverview');
						M.Modal.getInstance(editSettingsOverview).options.onCloseEnd = () => {
							location.reload();
						};
					})
					.catch(function (error) {
						console.error(error);
					});
			});
		});
	}
}

export { renderUserSettings };
